<div class="to-primary-600/20 flex min-h-screen flex-col bg-gradient-to-r from-neutral-50 from-[480px] to-[480px] px-20">
  <div class="flex items-center gap-2 py-4">
    <a>
      <img
        priority="true"
        alt="Product logo"
        width="43"
        height="32"
        [ngSrc]="'/assets/images/logo.svg'"
      />
    </a>
    <div>
      <div class="subheader-2">{{ "auth.header.system" | translate }}</div>
      <div class="paragraph-3">{{ "auth.header.administrating" | translate }}</div>
    </div>
  </div>
  <div class="mb-4 max-w-[720px] grow content-center">
    <div
      class="shadow-light rounded-3xl bg-neutral-100 p-8"
      [@authTypeChanged]="type()"
    >
      <div class="mb-6 flex items-center gap-4">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20 24C20 25.1046 19.1046 26 18 26C16.8954 26 16 25.1046 16 24C16 22.8954 16.8954 22 18 22C19.1046 22 20 22.8954 20 24Z"
            fill="#8E8E90"
          />
          <path
            d="M30 26C31.1046 26 32 25.1046 32 24C32 22.8954 31.1046 22 30 22C28.8954 22 28 22.8954 28 24C28 25.1046 28.8954 26 30 26Z"
            fill="#8E8E90"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.0488 4.00006L24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 13.4847 35.885 4.86475 25.5759 4.06118L25.5772 4.05641C25.0658 4.01782 24.5561 3.99922 24.0488 4.00006ZM24 40C32.8366 40 40 32.8366 40 24C40 22.6028 39.8209 21.2474 39.4844 19.9555C32.3195 20.4625 25.4718 17.0492 21.521 11.2049C18.6264 14.1577 14.5964 15.9933 10.1376 16.0051C8.77804 18.3573 8 21.0878 8 24C8 32.8366 15.1634 40 24 40ZM23.957 8.00006L24.0473 8.00007L24 8L23.957 8.00006Z"
            fill="#8E8E90"
          />
        </svg>
        <h1>Авторизація</h1>
      </div>
      <div class="mb-4 text-sm">
        <!-- Authentication Type Selector -->
        <div class="space-y-2">
          <label class="text-sm font-medium text-neutral-700">{{ "auth.authType.label" | translate }}</label>
          <div class="flex gap-2">
            <button
              type="button"
              class="rounded-md border border-neutral-300 px-3 py-2 text-sm transition-colors"
              [ngClass]="{ 'bg-primary-600 text-neutral-0': type() === authType.Otp, 'text-neutral-700 hover:bg-neutral-50': type() !== authType.Otp }"
              (click)="changeAuthType(authType.Otp)"
            >
              {{ "auth.authType.otp" | translate }}
            </button>
            <button
              type="button"
              class="rounded-md border border-neutral-300 px-3 py-2 text-sm transition-colors"
              [ngClass]="{ 'bg-primary-600 text-neutral-0': type() === authType.LoginPassword, 'text-neutral-700 hover:bg-neutral-50': type() !== authType.LoginPassword }"
              (click)="changeAuthType(authType.LoginPassword)"
            >
              {{ "auth.authType.loginPassword" | translate }}
            </button>
            <button
              type="button"
              class="rounded-md border border-neutral-300 px-3 py-2 text-sm transition-colors"
              [ngClass]="{ 'bg-primary-600 text-neutral-0': type() === authType.DepositSign, 'text-neutral-700 hover:bg-neutral-50': type() !== authType.DepositSign }"
              (click)="changeAuthType(authType.DepositSign)"
            >
              {{ "auth.authType.depositSign" | translate }}
            </button>
          </div>
        </div>
      </div>
      @switch (type()) {
        @case (authType.DepositSign) {
          <auth-ds></auth-ds>
        }
        @case (authType.Otp) {
          <auth-otp></auth-otp>
        }
        @default {
          <auth-login-password></auth-login-password>
        }
      }
    </div>
  </div>
</div>
